import React, { useState } from "react";
import { Modal, Checkbox, Col, InputNumber, Row, Slider } from "antd";
import {
  getDecimal,
  setDecimal,
  getModal,
  setModal,
  getSignificantFigures,
  setSignificantFigures,
  getEdgeType,
  setEdgeType,
  getProbabilitiesBlank,
  setProbabilitiesBlank,
} from "./UserSettings";
import { setRefreshNodes } from "./App";

import "../css/settings.css";

/*
Settings menu modal.
*/

const CheckboxGroup = Checkbox.Group;

export function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update state to force render
}

/*Procedure for adding a new setting:
    In UserSettings make sure the getSettingsMenu() function returns the new setting
    Import here the getter and setter for the new setting
    Add a corresponding line in the onCancel function
    Copy a "setting-line" div and change the text and the onChange function
*/

function Settings({ visible, openClose, originalSettings }) {
  const forceUpdate = useForceUpdate();

  const [inputValue, setInputValue] = useState(getSignificantFigures());
  const onChange = (newValue) => {
    if (newValue === null) {
      setInputValue(0);
    } else {
      setInputValue(newValue);
    }
    forceUpdate();
  };

  //Edge type display names dictionary
  const edgeTypeDisplay = {
    default: "Curve (Default)",
    straight: "Straight",
    smoothstep: "Step",
  };

  return (
    <Modal
      className="settings-modal"
      title={<text style={{ marginLeft: "5px" }}>Settings</text>}
      open={visible}
      maskClosable={false}
      closable={false}
      okText="Apply"
      onOk={() => {
        setSignificantFigures(inputValue);
        setRefreshNodes();
        openClose();
      }}
      onCancel={() => {
        setDecimal(originalSettings.isDecimal);
        setModal(originalSettings.isModal);
        setInputValue(originalSettings.significantFigures);
        setEdgeType(originalSettings.edgeType);
        setProbabilitiesBlank(originalSettings.probabilitiesBlank);
        openClose();
      }}
    >
      <div className="setting-line">
        <p>Display probabilities as: </p>
        <CheckboxGroup
          options={["Decimal", "Percentage"]}
          value={getDecimal() ? "Decimal" : "Percentage"}
          onChange={() => {
            setDecimal(!getDecimal());
            forceUpdate();
          }}
        />
      </div>

      <div className="setting-line">
        <p>(experimental) Node settings displayed as: </p>
        <CheckboxGroup
          options={["Modal", "Drawer"]}
          value={getModal() ? "Modal" : "Drawer"}
          onChange={() => {
            setModal(!getModal());
            forceUpdate();
          }}
        />
      </div>

      <div className="setting-line">
        <p>Edge type: </p>
        <CheckboxGroup
          options={["Curve (Default)", "Straight", "Step"]}
          value={edgeTypeDisplay[getEdgeType()]}
          onChange={(e) => {
            console.log(e);
            if (e.length === 0) {
              setEdgeType("default");
            } else {
              setEdgeType(
                Object.keys(edgeTypeDisplay).find(
                  (key) => edgeTypeDisplay[key] === e[0]
                )
              );
            }
            forceUpdate();
          }}
        />
      </div>

      <div className="setting-line">
        <p>When calculations are paused: </p>
        <CheckboxGroup
          options={["Blank probabilities", "Grey probabilities"]}
          value={
            getProbabilitiesBlank()
              ? "Blank probabilities"
              : "Grey probabilities"
          }
          onChange={(e) => {
            setProbabilitiesBlank(!getProbabilitiesBlank());
            forceUpdate();
          }}
        />
      </div>

      {/* <div className='setting-line'> */}
      <p>Significant figures: </p>
      <Row>
        <Col span={12}>
          <Slider
            min={0}
            max={5}
            onChange={onChange}
            value={typeof inputValue === "number" ? inputValue : 0}
          />
        </Col>
        <Col span={4}>
          <InputNumber
            min={0}
            max={5}
            style={{
              margin: "0 16px",
            }}
            value={inputValue}
            onChange={onChange}
          />
        </Col>
      </Row>
      {/* </div> */}
    </Modal>
  );
}

export default Settings;
